import { getProfileContactInfo } from 'routes/marketplace-ede/utils/profile';
import { getPrimaryContactInfo } from 'routes/marketplace-ede/utils/application';
import { EdeApplicationPayloadType } from 'routes/marketplace-ede/types/ede/edeApplication';
import { Profile } from 'routes/marketplace-ede/types/profile/profile';
import { PrimaryAttestation } from 'routes/marketplace-ede/types/base/edeApplication';
import { ProductApplicationType } from '../types/base/productApplication';
import { EXCHANGES } from '../constants/exchange';

export interface State {
  edeApplication: EdeApplicationPayloadType;
  attestations: {
    pageState: {
      productApplicants: unknown[];
    };
    primary?: PrimaryAttestation;
  };
  productApplications: ProductApplicationType;
  profile: Profile;
}

export const getCoverageState = (state: State) => {
  const { attestations, edeApplication = {}, profile = {} } = state;
  const primaryAttestations = attestations?.primary;
  const primaryContactInfo = getPrimaryContactInfo(edeApplication);
  const profileContactInfo = getProfileContactInfo(profile);

  return (
    primaryAttestations?.coverageState ||
    primaryContactInfo?.coverageState ||
    profileContactInfo?.coverageState
  );
};

export const isGAUser = (state: State): boolean => {
  const { productApplications } = state;

  return productApplications?.exchange === EXCHANGES.GAA;
};

export const edeProvider = (state: State): string => (isGAUser(state) ? 'GA' : 'CMS');
